import {
  Box,
  Center,
  SimpleGrid,
  TextInput,
  Title,
  Group,
  PasswordInput,
  Button,
} from '@mantine/core';
import { IconLock, IconUserCircle } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import IconImage1 from 'assets/Login/new_login_dashboard/campus_1.png';
import IconImage2 from 'assets/Login/new_login_dashboard/campus_2.png';
import IconImage3 from 'assets/Login/new_login_dashboard/campus_3.png';
import IconImage4 from 'assets/Login/new_login_dashboard/bottom_bg.png';
import IconImage5 from 'assets/Login/new_login_dashboard/wave.png';
import IconImage6 from 'assets/Login/new_login_dashboard/arrow_up.png';
import { ReactComponent as SDALogo } from 'assets/SDA.svg';

import TrainerImage1 from 'assets/Login/trainer/Daryl01.png';
import TrainerImage4 from 'assets/Login/trainer/Gold01.png';
import TrainerImage5 from 'assets/Login/trainer/grace01.png';
import TrainerImage6 from 'assets/Login/trainer/Joshua01.png';
import TrainerImage7 from 'assets/Login/trainer/Paul01.png';
import TrainerImage8 from 'assets/Login/trainer/Qisti01.png';

import { useForm, zodResolver } from '@mantine/form';
import { useDispatch } from 'react-redux';
import { API } from 'services';
import { setLoginUser } from 'redux/reducers/auth';
import { useMutation } from '@tanstack/react-query';
import { getErrorMessage } from 'services/getErrorMessage';
import { notifications } from 'notifications';
import { z } from 'zod';
import { GradientButton } from 'components/GradientButton';
import { ForgotPassword } from './ForgetPasswordModal';
import { useDisclosure } from '@mantine/hooks';
import styles from './LoginPage.module.scss';
import { useEffect } from 'react';
import { useLoginUser } from 'redux/selectors/useLoginUser';
import Slider from 'react-slick';

const schema = z.object({
  email: z.string().email({ message: 'Invalid email' }),
  password: z.string().nonempty({ message: 'Password is required' }),
});

type FormValue = z.infer<typeof schema>;

export const LoginPage = () => {
  const { loginUser } = useLoginUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [forgetPasswordOpened, forgetPasswordModalHelper] = useDisclosure(false);
  const form = useForm({
    initialValues: import.meta.env.DEV
      ? {
          email: '',
          password: '',
        }
      : {
          email: '',
          password: '',
        },
    validate: zodResolver(schema),
  });

  const handleLogin = useMutation(
    (values: FormValue) => {
      return API.login({
        email: values.email,
        password: values.password,
      })
        .then((res) => {
          return res.data;
        })
        .then((res) => {
          dispatch(
            setLoginUser({
              token: res.data.token,
              user: res.data.user,
            })
          );
          if (res.data.user.is_corporate == 1) {
            navigate('/profile', { replace: true });
          } else {
            navigate('/dashboard', { replace: true });
          }
          return res.data;
        });
    },
    {
      onError: (error) => {
        notifications.error({
          title: 'Login Failed',
          message: getErrorMessage(error),
        });
      },
    }
  );

  useEffect(() => {
    if (loginUser) {
      if (loginUser.is_corporate == 1) {
        navigate('/profile', { replace: true });
      } else {
        navigate('/dashboard', { replace: true });
      }
    }
  }, []);

  // Move the image to the left
  // const moveLeft = () => {
  //   const img = document.querySelector('.winImage2');
  //   if (img) {
  //     img.style.transition = 'transform 1s ease';
  //     img.style.transform = 'translateX(0%)';
  //   }
  // };

  // // Toggle the image visibility
  // const toggleImageVisibility = () => {
  //   const img = document.querySelector('.winImage2') as any;
  //   if (img) {
  //     if (img.style.display === 'none') {
  //       img.style.display = 'block';
  //     } else {
  //       img.style.display = 'none';
  //     }
  //   }
  // };

  // // Run the animation loop
  // useEffect(() => {
  //   const animationLoop = setInterval(() => {
  //     // Move the image left and then toggle visibility after 1 second
  //     // moveLeft();
  //     setTimeout(toggleImageVisibility, 1000);
  //   }, 5000); // Repeat every 10 seconds

  //   // Clear the interval on component unmount
  //   return () => clearInterval(animationLoop);
  // }, []);

  const slider_settings = {
    dots: false,
    prevArrow: <button style={{ display: 'none' }}></button>, // Hide previous button
    nextArrow: <button style={{ display: 'none' }}></button>, // Hide next button
    infinite: true,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  return (
    <SimpleGrid
      cols={2}
      w="100%"
      h="100vh"
      style={{ gap: 0 }}
      breakpoints={[
        {
          maxWidth: 'md',
          cols: 1,
        },
      ]}
    >
      <Box
        h={{ md: '100%' }}
        style={{
          position: 'relative',
          overflow: 'hidden',
          background: 'linear-gradient(to bottom, #00AB8420 0%, #fff 50%, #00AB8420 100%)',
        }}
      >
        {/* <BackgroundImage
          src={LoginImage}
          style={{
            backgroundPosition: 'center',
            width: '100%',
            height: '100%',
            position: 'relative',
          }}
        > */}
        <Center w="100%" h={'100%'} style={{ overflow: 'hidden' }}>
          {/* <img className={`${styles.win_image} winImage2`} src={WinImage2} alt="" /> */}
          <div className={styles.main_figure}></div>
          <div>
            <Slider className={styles.dk_image} {...slider_settings}>
              <div className={'trainer_box'}>
                <img src={TrainerImage1} alt="" className={'trainer_img'} />
                <div className={'trainer_message'}>
                  <p>
                    If You Work Hard on Your Job, You Can Make a Living. If You Work Hard on
                    Yourself, You Can Make a Fortune.
                  </p>
                  <span>Daryl Kang</span>
                </div>
              </div>
              <div className={'trainer_box'}>
                <div className={'trainer_message'}>
                  <p>
                    Upskilling, Reskilling and Lifelong Learning are the keys that unlock doors to
                    new opportunities, broaden horizons, and promote personal and professional
                    development in an ever-changing world.
                  </p>
                  <span>Gold Poovan</span>
                </div>
                <img src={TrainerImage4} alt="" className={'trainer_img'} />
              </div>
              <div className={'trainer_box'}>
                <div className={'trainer_message'}>
                  <p>
                    The more I learn, the more I realize how much I don’t know”. - Albert Einstein.
                    Never stop learning! 😎
                  </p>
                  <span>Grace Koh</span>
                </div>
                <img src={TrainerImage5} alt="" className={'trainer_img'} />
              </div>
              <div className={'trainer_box'}>
                <div className={'trainer_message'}>
                  <p>The Best Way to Predict Your Future is to Create it.</p>
                  <span>Joshua Judah</span>
                </div>
                <img src={TrainerImage6} alt="" className={'trainer_img'} />
              </div>
              <div className={'trainer_box'}>
                <div className={'trainer_message'}>
                  <p>Invest in Upskilling for Future Opportunities</p>
                  <span>Paul Lim</span>
                </div>
                <img src={TrainerImage7} alt="" className={'trainer_img'} />
              </div>
              <div className={'trainer_box'}>
                <div className={'trainer_message'}>
                  <p>
                    Lifelong learning is the secret to eternal youth; never stop finding joy in the
                    journey of knowledge and growth. For in the heart of all fun, lies the essence
                    of endless discovery.
                  </p>
                  <span>Qisti Razan Putra</span>
                </div>
                <img src={TrainerImage8} alt="" className={'trainer_img'} />
              </div>
            </Slider>
          </div>
          <img
            className={`login_dashboard_icon_1 ${styles.login_dashboard_icon_1}`}
            src={IconImage1}
            alt=""
          />
          <img
            className={`login_dashboard_icon_2 ${styles.login_dashboard_icon_2}`}
            src={IconImage2}
            alt=""
          />
          <img
            className={`login_dashboard_icon_3 ${styles.login_dashboard_icon_3}`}
            src={IconImage3}
            alt=""
          />
          <img className={`login_dashboard_icon_4`} src={IconImage4} alt="" />
          <img className={`login_dashboard_icon_5`} src={IconImage5} alt="" />
          <img className={`login_dashboard_icon_6`} src={IconImage6} alt="" />
        </Center>
        <div className={styles.sda_logo}>
          <SDALogo width={'100%'} height={'auto'} />
        </div>
        {/* </BackgroundImage> */}
      </Box>
      <Box bg="#F5FAFE" className="p-1">
        <Center style={{ flexDirection: 'column' }} h="100%">
          <Title color={'#003640'} className="text-center" weight={600}>
            {"Trainer's Portal"}
          </Title>
          <p className={`font-poppins ${styles.signInText}`}>Sign In</p>
          <form
            onSubmit={form.onSubmit((values) => handleLogin.mutateAsync(values))}
            style={{
              marginTop: 10,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 10,
            }}
          >
            <TextInput
              {...form.getInputProps('email')}
              size="lg"
              w={'80%'}
              maw={400}
              mb={10}
              label="Email"
              icon={<IconUserCircle color="#cccccc" />}
              placeholder="Email@example.com"
              classNames={{ label: styles.label, input: styles.input, wrapper: styles.wrapper }}
            />

            <PasswordInput
              {...form.getInputProps('password')}
              size="lg"
              w={'80%'}
              maw={400}
              label="Password"
              icon={<IconLock color="#cccccc" />}
              placeholder="Password"
              classNames={{ label: styles.label, input: styles.input, wrapper: styles.wrapper }}
            />

            <Group position="left" w={'80%'} maw={400}>
              <Button
                unstyled
                component="a"
                onClick={() => {
                  forgetPasswordModalHelper.open();
                }}
                classNames={{ root: styles.forgetpassword_label }}
              >
                Forget Password
              </Button>
            </Group>

            <GradientButton
              type="submit"
              loading={handleLogin.isLoading}
              size="md"
              w={'80%'}
              mt={20}
              maw={300}
            >
              Sign In
            </GradientButton>
          </form>
          <ForgotPassword opened={forgetPasswordOpened} onClose={forgetPasswordModalHelper.close} />
        </Center>
      </Box>
    </SimpleGrid>
  );
};
